import Vue from 'vue'

const digitsRE = /(\d{3})(?=\d)/g

/**
 * 12345 => R$12.345,00
 *
 * @param value
 * @param {String} currency
 * @param {Number} decimals Decimal places
 * @param {String} decimalPoint
 * @param {String} thousandSeparator
 */
const currency = function currency (
  value, currency = '', decimals = 2, decimalPoint = ',',
  thousandSeparator = '.') {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''

  currency = currency != null ? currency : 'R$'
  let stringified = Math.abs(value).toFixed(decimals)
  stringified = stringified.replace('.', decimalPoint)
  let _int = stringified.slice(0, -1 - decimals)
  let i = _int.length % 3
  let head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? thousandSeparator : ''))
    : ''
  let _float = stringified.slice(-1 - decimals)
  let sign = value < 0 ? '-' : ''
  return sign + currency + ' ' + head +
    _int.slice(i).replace(digitsRE, '$1' + thousandSeparator) +
    _float
}

const formatDate = function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
  return null
}

const formatDatetime = function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
  return null
}

const paymentTypeLabel = function (value) {
  const types = {
    billet: 'Boleto',
    billet_rm: 'Boleto RM',
    billet_cobmais: 'Boleto Cobmais',
    credit_card: 'Cartão de Crédito',
    debit_card: 'Cartão de Débito',
    bank_transfer: 'Transferência',
    cash: 'Dinheiro',
    discount: 'Desconto',
    effective_less: 'Efetivo Menos',
    effective_more: 'Efetivo Mais',
    refinanced: 'Pgto Refin',
  }
  return (types[value] == undefined) ? value : types[value]
}

const capitalize = function (value) {
  if (!value) return value
  value = value.toString().toLowerCase()
  
  var valueArray = value.split(" ");
  var newValue = ""

  var i;
  for (i = 0; i < valueArray.length; i++) {
    if(valueArray[i] == ''){
      continue;
    }
    if(['da','de','do','das','dos'].includes(valueArray[i])){
      newValue += valueArray[i] + " ";
    }else{
      newValue += valueArray[i].charAt(0).toUpperCase() + valueArray[i].slice(1) + " ";
    }
  }

  return newValue.trim()
}

// Vue.filter(currency)
// Vue.filter('formatDate',formatDate)
// Vue.filter(formatDatetime())

// export default {
//   currency,
//   formatDate,
//   formatDatetime,
// }
export default {
  'currency': currency,
  'formatDate': formatDate,
  'formatDatetime': formatDatetime,
  'paymentTypeLabel': paymentTypeLabel,
  'capitalize': capitalize,
}


// WEBPACK FOOTER //
// ./resources/assets/js/filters.js